import { defineComponent, computed } from "vue";
import { definePropType } from "@types-vue/props";
import IconLanguage from "@com/components/language-selector/icon-language.vue";
import { isApprovedPartner } from "./utils";
export default defineComponent({
    name: "PartnerInfo",
    props: {
        value: {
            type: String,
            required: true
        },
        list: {
            type: definePropType(Array),
            required: true
        },
        countries: {
            type: definePropType(Array),
            required: true
        }
    },
    components: {
        IconLanguage: IconLanguage
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var getCountryName = function getCountryName(code, countryList) {
            var item1 = countryList.find(function(item) {
                return item.value === code;
            });
            if (item1) {
                return "".concat(item1.label, " (").concat(item1.value, ")");
            }
            return code;
        };
        var val = computed({
            get: function get() {
                return props.value;
            },
            set: function set(value) {
                emit("input", value);
            }
        });
        return {
            val: val,
            getCountryName: getCountryName,
            isApprovedPartner: isApprovedPartner
        };
    }
});
